let $ = jQuery

export default {
	post( data ){
		return new Promise( (resolve, reject, req = false) => {
			if ( ! data._wpnonce ) {
				data._wpnonce = xkit_params.xkit_nonce
			}

			req = $.ajax( {
				type: "POST",
				url: xkit_params.ajax_url,
				data,
			} ).done( function ( res, textStatus, jqXHR  ) {
				if ( ! res.data ) {
					resolve( {data: { err: 'true', html: 'Something went wrong' } } )
					return res;
				}
				resolve( res )
			} ).fail( function ( res ) {
				resolve( {data: { err: 'true', html: 'Something went wrong' } } )
			} )

			// req.cancel = function () { // specify cancellation
			// 	xhr.abort(); // abort request
			// 	reject({data: { err: 'true', html: 'Something went wrong' } }); // reject the promise
			// };
		})
	},
}